import { createFileRoute } from '@tanstack/react-router'
import { AcquiredUserBannerPage } from '@/features/acquired-user-banner'

export const Route = createFileRoute('/_authenticated/acquired-user-banner/')({
  component: AcquiredUserBannerPage,
})
